function HousekeepingReport() {
  return (
    <>
      <div className="font-bold text-lg mb-16">Housekeeping Report</div>
    </>
  );
}

export default HousekeepingReport;
